module.exports = __webpack_public_path__ + "img/avatar0.6c317b58.png";